/**
 * GLOSSYWHITE PREVIEW - Canvas-basierte Live-Vorschau
 * Geburtstag-Topf mit Zahl, zwei Textzeilen und Icon
 */

const GlossyWhitePreview = {
  // ========================================
  // KONFIGURATION (ANPASSBAR!)
  // ========================================
  config: {
    // Base-Produktbild
    baseImage: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/Design_ohne_Titel_12_eae9d8a5-49c8-4e29-b3f2-ff84a6316a06.png?v=1763997105',

    // Canvas-Dimensionen
    canvasWidth: 800,
    canvasHeight: 800,

    // Icon-URLs (1-27) - neue Icons
    iconUrls: {
      1: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/1_c75d38a0-53c1-4887-8c55-98fcdb8f721e.png?v=1764082344',
      2: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/2_0b9fa02f-ebd3-4c9d-a544-c90c39f75756.png?v=1764082342',
      3: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/3_bb38b5a8-beec-4afa-98a5-1158bc6f6487.png?v=1764082343',
      4: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/4_38b6a8b4-0860-46a8-9649-920449fa19ea.png?v=1764082343',
      5: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/5_bc0b46b2-c613-4506-82b4-b24668d7648d.png?v=1764082342',
      6: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/6_b78604c7-1a79-44dd-b239-af6af9dafe65.png?v=1764082343',
      7: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/7_5ecb7ffb-2a2d-4802-b6d6-97988302df45.png?v=1764082344',
      8: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/8_91b3271e-e82d-431e-b17d-ec04cff73680.png?v=1764082343',
      9: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/9_d45e06a5-c49d-4f26-9561-6556b5fdeb9c.png?v=1764082343',
      10: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/10_c7046ae1-1ed1-415d-907f-6b77a6a4c2c0.png?v=1764082343',
      11: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/11_1a8f2e02-16e9-46ff-b02d-293aa0119710.png?v=1764082344',
      12: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/12_5851b6d1-b22f-4042-8944-818a81a39e8d.png?v=1764082342',
      13: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/13_86160fd3-9812-49c4-84dd-bac68dfda0fb.png?v=1764082343',
      14: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/14_329b06ee-9d04-4d79-a8c9-15373ae335a8.png?v=1764082343',
      15: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/15_a598bb05-ae41-4cfb-aad3-d8c9fde62c9c.png?v=1764082343',
      16: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/16_f3935719-4166-4699-97b6-1dfd198db6d3.png?v=1764082343',
      17: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/17_7d9d6445-5bff-4a5f-9ef8-c403b424e1e7.png?v=1764082343',
      18: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/18_c29911eb-c859-4ea5-a515-566d117c9f30.png?v=1764082343',
      19: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/19_c72620c0-1b0b-4389-aee9-3b9647c3c781.png?v=1764082343',
      20: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/20_a29abc30-f0be-46d2-969d-3a54ed9c18b6.png?v=1764082343',
      21: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/21_b9cf131b-eaa0-44b0-836b-f46a082d0534.png?v=1764082343',
      22: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/22_c407c665-c0c8-448e-9ee4-78f9a221c75d.png?v=1764082343',
      23: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/23_a55c35a0-c769-4fda-802b-7324c5fa406b.png?v=1764082342',
      24: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/24_376eba4a-533f-4b9b-b2b2-49d6d8f4e1e7.png?v=1764082344',
      25: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/25_b5dee59a-7919-47d2-abba-e7a2c9c34ac6.png?v=1764082344',
      26: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/26_a6e77853-63cf-4185-a82b-a48ca197147b.png?v=1764082342',
      27: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/27_7398808f-23b3-4311-b3da-d6fb1c6072f9.png?v=1764082343'
    },

    // Text-Positionen und Styles
    textConfig: {
      zahl: {
        x: 400,           // Zentriert
        y: 380,           // Oben auf dem Topf
        fontSize: 105,    // Größere Zahl
        fontFamily: 'Bebas Neue',
        color: '#4a4a4a', // Dunkelgrau
        align: 'center',
        baseline: 'middle'
      },
      textzeile1: {
        x: 400,           // Zentriert
        y: 475,           // Unter der Zahl
        fontSize: 38,     // Größerer Text
        fontFamily: 'Glacial Indifference',
        color: '#4a4a4a',
        align: 'center',
        baseline: 'middle'
      },
      textzeile2: {
        x: 400,           // Zentriert
        y: 515,           // Unter Textzeile 1
        fontSize: 36,     // Größerer Text
        fontFamily: 'Glacial Indifference',
        color: '#5a5a5a',
        align: 'center',
        baseline: 'middle'
      }
    },

    // Icon-Position und Größe
    iconConfig: {
      x: 400,             // Zentriert
      y: 620,             // Nach oben
      maxWidth: 150,      // Max. Breite
      maxHeight: 150      // Max. Höhe
    }
  },

  // Interner State
  canvas: null,
  ctx: null,
  images: {
    base: null,
    icon: null
  },
  fontsLoaded: false,
  isRendering: false,

  /**
   * Initialisierung
   */
  init() {
    // Canvas-Element finden
    this.canvas = document.getElementById('glossywhite-preview-canvas');
    if (!this.canvas) {
      console.error('GlossyWhite: Canvas element not found');
      return;
    }

    this.ctx = this.canvas.getContext('2d');

    // Event Listeners registrieren
    this.setupEventListeners();

    // Fonts vorladen
    this.loadFonts();

    // Base Image vorladen
    this.loadBaseImage();

    // Warenkorb-Integration einrichten
    this.setupCartIntegration();

    console.log('GlossyWhitePreview initialized');
  },

  /**
   * Event Listeners einrichten
   */
  setupEventListeners() {
    // Vorschau-Button
    const previewBtn = document.getElementById('glossywhite-preview-btn');
    if (previewBtn) {
      previewBtn.addEventListener('click', () => this.openPreview());
    }

    // Modal schließen
    const closeBtn = document.querySelector('.glossywhite-preview-close');
    if (closeBtn) {
      closeBtn.addEventListener('click', () => this.closePreview());
    }

    // Modal-Hintergrund klicken
    const modal = document.getElementById('glossywhite-preview-modal');
    if (modal) {
      modal.addEventListener('click', (e) => {
        if (e.target.id === 'glossywhite-preview-modal') {
          this.closePreview();
        }
      });
    }

    // ESC-Taste zum Schließen
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        this.closePreview();
      }
    });
  },

  /**
   * Fonts laden und auf Bereitschaft warten
   */
  async loadFonts() {
    try {
      // Warten bis Fonts geladen sind
      await document.fonts.ready;

      // Fonts explizit laden
      await document.fonts.load('105px "Bebas Neue"');
      await document.fonts.load('24px "Glacial Indifference"');

      this.fontsLoaded = true;
      console.log('GlossyWhite: ✓ Fonts loaded successfully');
    } catch (error) {
      console.error('GlossyWhite: Error loading fonts:', error);
      this.fontsLoaded = true; // Trotzdem weitermachen
    }
  },

  /**
   * Base-Produktbild vorladen
   */
  loadBaseImage() {
    this.images.base = new Image();
    this.images.base.crossOrigin = 'anonymous';
    this.images.base.onload = () => {
      console.log('GlossyWhite: ✓ Base image loaded');
    };
    this.images.base.onerror = () => {
      console.error('GlossyWhite: ✗ Failed to load base image');
    };
    this.images.base.src = this.config.baseImage;
  },

  /**
   * Icon-Bild laden
   */
  loadIcon(iconNumber) {
    return new Promise((resolve, reject) => {
      if (!iconNumber) {
        this.images.icon = null;
        resolve();
        return;
      }

      const iconUrl = this.config.iconUrls[iconNumber];

      if (!iconUrl) {
        console.error(`GlossyWhite: Icon ${iconNumber} not found`);
        this.images.icon = null;
        resolve();
        return;
      }

      this.images.icon = new Image();
      this.images.icon.crossOrigin = 'anonymous';

      this.images.icon.onload = () => {
        console.log(`GlossyWhite: ✓ Icon ${iconNumber} loaded`);
        resolve();
      };

      this.images.icon.onerror = () => {
        console.error(`GlossyWhite: ✗ Failed to load icon ${iconNumber}`);
        this.images.icon = null;
        resolve(); // Trotzdem weitermachen
      };

      this.images.icon.src = iconUrl;
    });
  },

  /**
   * Vorschau-Modal öffnen
   */
  async openPreview() {
    if (this.isRendering) return;

    // Validierung
    const formData = this.getFormData();
    if (!formData.zahl || !formData.textzeile1 || !formData.icon) {
      alert('Bitte fülle alle Pflichtfelder aus (Zahl, Textzeile 1 und Icon).');
      return;
    }

    // Felder mit Warenkorb synchronisieren
    this.syncFieldsToCart();

    const modal = document.getElementById('glossywhite-preview-modal');
    const loading = document.getElementById('glossywhite-preview-loading');
    const canvas = this.canvas;

    // Modal anzeigen
    modal.classList.add('active');
    loading.style.display = 'block';
    canvas.style.display = 'none';

    // Kurz warten für Modal-Animation
    await new Promise(resolve => setTimeout(resolve, 100));

    // Vorschau rendern
    await this.renderPreview();

    // Canvas anzeigen
    loading.style.display = 'none';
    canvas.style.display = 'block';
  },

  /**
   * Vorschau-Modal schließen
   */
  closePreview() {
    const modal = document.getElementById('glossywhite-preview-modal');
    modal.classList.remove('active');
  },

  /**
   * Form-Daten auslesen
   */
  getFormData() {
    // Icon aus Radio Buttons auslesen
    const iconRadio = document.querySelector('input[name="gw-icon"]:checked');

    return {
      zahl: document.getElementById('gw-zahl')?.value || '',
      textzeile1: document.getElementById('gw-textzeile1')?.value || '',
      textzeile2: document.getElementById('gw-textzeile2')?.value || '',
      icon: iconRadio?.value || ''
    };
  },

  /**
   * Warenkorb-Integration einrichten
   */
  setupCartIntegration() {
    // Hidden Fields ins Product Form einfügen
    const productForm = document.querySelector('form[action*="/cart/add"]');
    const hiddenFields = document.getElementById('gw-hidden-fields');

    if (productForm && hiddenFields) {
      // Hidden Fields ins Form verschieben
      productForm.appendChild(hiddenFields);
      console.log('GlossyWhite: ✓ Hidden fields moved to product form');
    } else {
      console.warn('GlossyWhite: ⚠ Product form or hidden fields not found');
    }

    // Bei Input-Änderungen automatisch synchronisieren
    const inputs = document.querySelectorAll('.gw-input');
    inputs.forEach(input => {
      input.addEventListener('change', () => this.syncFieldsToCart());
      input.addEventListener('blur', () => this.syncFieldsToCart());
    });

    // Bei Radio Button Änderungen synchronisieren
    const radioButtons = document.querySelectorAll('input[name="gw-icon"]');
    radioButtons.forEach(radio => {
      radio.addEventListener('change', () => this.syncFieldsToCart());
    });

    // Bei Form Submit synchronisieren
    if (productForm) {
      productForm.addEventListener('submit', () => {
        this.syncFieldsToCart();
      });
    }

    console.log('GlossyWhite: ✓ Cart integration setup complete');
  },

  /**
   * Felder mit Hidden Fields synchronisieren
   */
  syncFieldsToCart() {
    const formData = this.getFormData();

    // Werte in Hidden Fields kopieren
    const hiddenFields = {
      'gw-hidden-zahl': formData.zahl,
      'gw-hidden-textzeile1': formData.textzeile1,
      'gw-hidden-textzeile2': formData.textzeile2,
      'gw-hidden-icon': formData.icon ? `Icon ${formData.icon}` : ''
    };

    Object.keys(hiddenFields).forEach(id => {
      const field = document.getElementById(id);
      if (field) {
        field.value = hiddenFields[id];
      }
    });

    console.log('GlossyWhite: ✓ Fields synced to cart:', formData);
  },

  /**
   * Hauptfunktion: Vorschau rendern
   */
  async renderPreview() {
    if (this.isRendering) return;
    this.isRendering = true;

    try {
      const ctx = this.ctx;
      const canvas = this.canvas;

      // Canvas leeren
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      // Form-Daten holen
      const formData = this.getFormData();

      // 1. Base-Bild zeichnen
      if (this.images.base && this.images.base.complete) {
        ctx.drawImage(this.images.base, 0, 0, canvas.width, canvas.height);
      } else {
        // Fallback: Weißer Hintergrund
        ctx.fillStyle = '#ffffff';
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        console.warn('GlossyWhite: Base image not loaded, using white background');
      }

      // 2. Zahl zeichnen
      if (formData.zahl) {
        this.drawText('zahl', formData.zahl);
      }

      // 3. Textzeile 1 zeichnen
      if (formData.textzeile1) {
        this.drawText('textzeile1', formData.textzeile1);
      }

      // 4. Textzeile 2 zeichnen (optional)
      if (formData.textzeile2) {
        this.drawText('textzeile2', formData.textzeile2);
      }

      // 5. Icon laden und zeichnen (wenn ausgewählt)
      if (formData.icon) {
        await this.loadIcon(formData.icon);
        this.drawIcon();
      }

      console.log('GlossyWhite: ✓ Preview rendered successfully');
    } catch (error) {
      console.error('GlossyWhite: Error rendering preview:', error);
    } finally {
      this.isRendering = false;
    }
  },

  /**
   * Text zeichnen
   */
  drawText(fieldName, text) {
    if (!text) return;

    const config = this.config.textConfig[fieldName];
    if (!config) return;

    const ctx = this.ctx;

    // Text auf maxlength begrenzen
    if (fieldName === 'zahl') {
      text = text.substring(0, 3);
    } else {
      text = text.substring(0, 20);
    }

    // Font-Style setzen
    ctx.font = `${config.fontSize}px "${config.fontFamily}"`;
    ctx.fillStyle = config.color;
    ctx.textAlign = config.align;
    ctx.textBaseline = config.baseline;

    // Text-Schatten für bessere Lesbarkeit
    ctx.shadowColor = 'rgba(255, 255, 255, 0.5)';
    ctx.shadowBlur = 4;
    ctx.shadowOffsetX = 2;
    ctx.shadowOffsetY = 2;

    // Text zeichnen
    ctx.fillText(text, config.x, config.y);

    // Schatten zurücksetzen
    ctx.shadowColor = 'transparent';
    ctx.shadowBlur = 0;
    ctx.shadowOffsetX = 0;
    ctx.shadowOffsetY = 0;
  },

  /**
   * Icon zeichnen
   */
  drawIcon() {
    if (!this.images.icon) return;

    const config = this.config.iconConfig;
    const icon = this.images.icon;

    // Skalierung berechnen (aspect ratio beibehalten)
    let width = icon.width;
    let height = icon.height;

    const scale = Math.min(
      config.maxWidth / width,
      config.maxHeight / height,
      1 // Nicht größer als Original
    );

    width *= scale;
    height *= scale;

    // Zentriert an Position zeichnen
    this.ctx.drawImage(
      icon,
      config.x - width / 2,
      config.y - height / 2,
      width,
      height
    );
  }
};

// Auto-Initialisierung wenn DOM bereit
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => GlossyWhitePreview.init());
} else {
  GlossyWhitePreview.init();
}

// Für Debugging im Browser-Console
window.GlossyWhitePreview = GlossyWhitePreview;
